import { Box } from '@chakra-ui/react';

import { DoubleChevronUpIcon } from 'Asset/icon';

import styles from './styles.module.css';

const ScrollToTop = ({ show, onClick, bottom = '100px', right = '16px' }) => {
  return (
    <Box
      data-testid="scroll-to-top"
      className={styles['scroll-to-top__container']}
      onClick={onClick}
      transform={show ? 'translateY(0)' : 'translateY(400%)'}
      bottom={bottom}
      right={right}
    >
      <DoubleChevronUpIcon size="32px" color="var(--color-semantic-white)" />
    </Box>
  );
};

export default ScrollToTop;
